class CustomBundleBuilder extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(this).css({ opacity: "1" });
      var filtercustom = new Swiper(".product-list-media", {
        spaceBetween: 0,
        slidesPerView: 1,
        freeMode: false,
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });

      $(".mobile-adding-products-button")
        .unbind()
        .click(function () {
          $(".custom-bundle-builder-product-right").addClass("active");
          $("body").css({ overflow: "hidden" });
        });

      $(".custom-back-button")
        .unbind()
        .click(function () {
          $(".custom-bundle-builder-product-right").removeClass("active");
          $("body").css({ overflow: "unset" });
        });

      $(".mobile-see-more-details")
        .unbind()
        .click(function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(250);
            $this.text("See Details");
          } else {
            $this.text("Hide Details");
            $this.next().toggleClass("show");
            $this.next().slideToggle(250);
          }
        });

      var isincart = "false";
      var cval = "1 month subscription with 15% discount"; // IA 2026-10-03: real 15% plan name
      // IA 2026-10-02: subscription mode comes ONLY from the visible toggle (never from storage left by an earlier bundle).
      var sval = "onetime";
      function iaSubMode() {
        var r = $(".custom-subscription-container .subscription-type:checked");
        return r.length && r.val() === "subscription" ? "subscription" : "onetime";
      }
      var discount1 = $(this).data("discount1");
      var discountnum1 = $(this).data("discountnum1");
      var discount1item = $(this).data("discount1item");
      var discount2 = $(this).data("discount2");
      var discountnum2 = $(this).data("discountnum2");
      var discount2item = $(this).data("discount2item");
      var discount3 = $(this).data("discount3");
      var discountnum3 = $(this).data("discountnum3");
      var discount3item = $(this).data("discount3item");
      var discount4 = $(this).data("discount4");
      var discountnum4 = $(this).data("discountnum4");
      var discount4item = $(this).data("discount4item");
      var discount5 = $(this).data("discount5");
      var discountnum5 = $(this).data("discountnum5");
      var discount5item = $(this).data("discount5item");

      var activeDiscount = null;
      var activeDiscountNum = null;
      var activeDiscountCode = null;
      var checkouturl = null;
      var discounts = [
        discount1item,
        discount2item,
        discount3item,
        discount4item,
        discount5item,
      ]; 
      var discountNums = [
        discountnum1,
        discountnum2,
        discountnum3,
        discountnum4,
        discountnum5,
      ];
      var discountCode = [
        discount1,
        discount2,
        discount3,
        discount4,
        discount5,
      ];

      var discountPairs = discounts
        .map((value, index) => ({
          value,
          num: discountNums[index],
          code: discountCode[index],
        }))
        .filter((triple) => triple.value !== "")
        .sort((a, b) => a.value - b.value);

      $(".custom-subscription-container .subscription-type").change(
        function () {
          sval = $(this).val();
          console.log("fsdfsdf==" + sval);
          localStorage.setItem("subscriptiontype", sval);
          sessionStorage.setItem("subscriptiontype", sval);
          setSelectedView();
        }
      ); 

      $(
        ".custom-subscription-container .button-container input[type='radio']"
      ).change(function () {
        cval = $(this).val();
        console.log("dfgdfgdf==" + cval);
      });


      $(".custom-product-atc-container .selling-plans").each(function () {
        $(this)
          .find("option")
          .each(function () {
            var str = $(this).attr("value");
            $(this).attr("value", str);
          });
        if (
          $(this).parents(".product-list-wrapper-main").data("incart") == true
        ) {  
          var planid = $(this)
            .parents(".product-list-wrapper-main")
            .data("planid");  
          var val = $(this)
            .parent()
            .find('option[data-planid="' + planid + '"]')
            .attr("value");
          $(this).val(val);
          $(this)
            .parents(".custom-product-atc-container")
            .find(".item-count")
            .attr(
              "data-sellingplan",
              $(this)
                .find('option[value="' + val + '"]')
                .attr("data-planid")
            );
          isincart = $(this)
            .parents(".product-list-wrapper-main")
            .data("incart");
          cval = val;
          console.log("cval==" + cval);
        } else {
          $(this).val("1 month subscription with 15% discount");
          $(this)
            .parents(".custom-product-atc-container")
            .find(".item-count")
            .attr(
              "data-sellingplan",
              $(this)
                .find('option[value="1 month subscription with 15% discount"]')
                .attr("data-planid")
            );
        }
      }); 

      if (isincart == true) {
        // IA 2026-10-02: restore the toggle from the cart's own bundle lines (selling plan present = subscription).
        var iaCartSub = false;
        $(".product-list-wrapper-main").each(function () {
          if ($(this).data("incart") == true && Number($(this).data("planid")) > 0) iaCartSub = true;
        });
        var getsubtype = iaCartSub ? "subscription" : "onetime";
        sessionStorage.setItem("subscriptiontype", getsubtype);
        console.log(
          getsubtype + "    " + isincart + "    " + cval + "  " + sval
        );
        $(".button-container input[type='radio']").each(function () {
          if ($(this).val() === cval) {
            $(this).prop("checked", true);
          }
        });

        $(
          ".custom-subscription-container .sub-container .subscription-type[type='radio']"
        ).prop("checked", false);
        $(
          ".custom-subscription-container .sub-container .subscription-type[type='radio'][value='" +
            getsubtype +
            "']"
        ).prop("checked", true);
      } else {
        console.log(
          "iscartempty==" +
            "  " +
            getsubtype +
            "    " +
            isincart +
            "    " +
            cval +
            "  " +
            sval
        );
        localStorage.setItem("subscriptiontype", "onetime");
        sessionStorage.setItem("subscriptiontype", "onetime");
        $(
          ".custom-subscription-container .sub-container .subscription-type[type='radio']"
        ).prop("checked", false);
        $(
          ".custom-subscription-container .sub-container .subscription-type[type='radio'][value='onetime']"
        ).prop("checked", true);
      }
      sval = iaSubMode();

      $(".custom-product-atc")
        .unbind()
        .click(function () {
          $(this).parents(".product-list-wrapper-main").addClass("active");
          var qty =
            Number(
              $(this)
                .parents(".product-list-wrapper-main")
                .find(".item-count")
                .val()
            ) + 1;
          console.log("qty==" + qty);
          $(this)
            .parents(".product-list-wrapper-main")
            .find(".item-count")
            .val(qty);

          $(this)
            .parents(".product-list-wrapper-main")
            .find(".totaladdedproduct")
            .html("(" + qty + ")");

          setSelectedView();
        });

      $(".button-container input[type='radio']").change(function () {
        console.log($(this).val());
        var selval = $(this).val();
        $(".product-list-wrapper-main").each(function () {
          $(this)
            .find(".selling-plans")
            .find('option[value="' + selval + '"]')
            .prop("selected", "selected");
          var elem = $(this)
            .find(".selling-plans")
            .find('option[value="' + selval + '"]');
          console.log(elem.data("planid"));
          $(this)
            .find(".item-count")
            .attr("data-sellingplan", elem.data("planid"));
          $(this)
            .find(".item-count")
            .attr("data-sellingprice", elem.data("planprice"));
        });
        setSelectedView();
      });

      $(".product-close-btn").click(function () {
        $(this).parents(".product-list-wrapper-main").addClass("active");
        var qty =
          Number(
            $(this)
              .parents(".product-list-wrapper-main")
              .find(".item-count")
              .val()
          ) - 1;
        $(this)
          .parents(".product-list-wrapper-main")
          .find(".item-count")
          .val(qty);
        $(this)
          .parents(".product-list-wrapper-main")
          .find(".totaladdedproduct")
          .html("(" + qty + ")");
        if (qty == 0) {
          $(this)
            .parents(".product-list-wrapper-main")
            .find(".totaladdedproduct")
            .html("");
          $(this).parents(".product-list-wrapper-main").removeClass("active");
        }
        setSelectedView();
      });

      $(".product-bundle-variant-1").change(function () {
        var varoption1value = $(this).val();
        var varoption2value = $(this)
          .parents(".product-list-wrapper-main")
          .find(".product-bundle-variant-2")
          .val();

        $(".error-var-response").css({ display: "none" });

        $(this)
          .parents(".product-list-wrapper-main")
          .find(".product-bundle-variants-main option")
          .each(function (i) {
            var varoption1 = $(this).data("option1");
            var varoption2 = $(this).data("option2");

            if (varoption1 != "" && varoption2 != "") {
              if (
                varoption1 == varoption1value &&
                varoption2 == varoption2value
              ) {
                var varname = varoption1value + " / " + varoption2value;

                var variant_id = $(this)
                  .parents(".product-list-wrapper-main")
                  .find(
                    '.product-bundle-variants-main option[data-copvartitle="' +
                      varname +
                      '"]'
                  )
                  .val();

                $(this)
                  .parents(".product-list-wrapper-main")
                  .find(".custom-product-atc-container .item-count")
                  .data("varid", variant_id);
                console.log("variant_id===" + variant_id);

                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".product-list-wrapper-main")
                  .find(".custom-product-atc-container .item-count")
                  .attr("data-varid", productvarid);

                console.log(
                  "varname===" +
                    varname +
                    "   " +
                    "productvarid===" +
                    productvarid
                );

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .removeClass("disabled");

                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .html("+ Add to cart");
                } else {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .addClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .text("Sold Out");
                }
              }
            } else if (varoption1 == "") {
              if (varoption2 == varoption2value) {
                var varname = varoption2value;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".product-list-wrapper-main")
                  .find(".custom-product-atc-container .item-count")
                  .attr("data-varid", productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .removeClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .html("+ Add to cart");
                } else {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .addClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .text("Sold Out");
                }
              }
            } else if (varoption2 == "") {
              if (varoption1 == varoption1value) {
                var varname = varoption1;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".product-list-wrapper-main")
                  .find(".custom-product-atc-container .item-count")
                  .attr("data-varid", productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .removeClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .html("+ Add to cart");
                } else {  
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .addClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .text("Sold Out");
                }
              }
            }
          });
      });

      $(".product-bundle-variant-2").change(function () {
        var varoption2value = $(this).val();
        var varoption1value = $(this)
          .parents(".product-list-wrapper-main")
          .find(".product-bundle-variant-1")
          .val();

        $(".error-var-response").css({ display: "none" });

        $(this)
          .parents(".product-list-wrapper-main")
          .find(".product-bundle-variants-main option")
          .each(function (i) {
            var varoption1 = $(this).data("option1");
            var varoption2 = $(this).data("option2");

            if (varoption1 != "" && varoption2 != "") {
              if (
                varoption1 == varoption1value &&
                varoption2 == varoption2value
              ) {
                var varname = varoption1value + " / " + varoption2value;

                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".product-list-wrapper-main")
                  .find(".custom-product-atc-container .item-count")
                  .attr("data-varid", productvarid);

                console.log(
                  "varname===" +
                    varname +
                    "   " +
                    "productvarid===" +
                    productvarid
                );

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .removeClass("disabled");

                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .html("+ Add to cart");
                } else {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .addClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .text("Sold Out");
                }
              }
            } else if (varoption1 == "") {
              if (varoption2 == varoption2value) {
                var varname = varoption2value;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".product-list-wrapper-main")
                  .find(".custom-product-atc-container .item-count")
                  .attr("data-varid", productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .removeClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .html("+ Add to cart");
                } else {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .addClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .text("Sold Out");
                }
              }
            } else if (varoption2 == "") {
              if (varoption1 == varoption1value) {
                var varname = varoption1;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".product-list-wrapper-main")
                  .find(".custom-product-atc-container .item-count")
                  .attr("data-varid", productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .removeClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .html("+ Add to cart");
                } else {
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-product-atc-container")
                    .addClass("disabled");
                  $(this)
                    .parents(".product-list-wrapper-main")
                    .find(".custom-atc-text-main")
                    .text("Sold Out");
                }
              }
            }
          });
      });

      setSelectedView();
      function setSelectedView() {
        sval = iaSubMode();
        $(".error-msg").remove();
        $(".discount-active-product").remove();
        var totalitem = 0;
        var totalprice = 0;

        var symbol = $("body").data("currency");
        $(".product-list-wrapper-main.active").each(function () {
          totalitem = totalitem + Number($(this).find(".item-count").val());
        });

        $(".total-bundle-products").text(totalitem);

        $(".product-list-wrapper-main.active").each(function () {
          var price = "";
          var onetimeprice =
            Number($(this).find(".item-count").data("pprice")) *
            Number($(this).find(".item-count").val());

          if (sval == "subscription") {
            price =
              Number($(this).find(".item-count").data("sellingprice")) *
              Number($(this).find(".item-count").val());
          } else {
            price =
              Number($(this).find(".item-count").data("pprice")) *
              Number($(this).find(".item-count").val());
          }

          totalprice = totalprice + price;

          var pricedisc = price;
          var displayprice = "";

          function pricecheckDiscounts() {
            activeDiscount = null;
            activeDiscountNum = null;
            activeDiscountCode = null;

            for (let i = 0; i < discountPairs.length; i++) {
              if (totalitem >= discountPairs[i].value) {
                activeDiscount = discountPairs[i].value;
                activeDiscountNum = discountPairs[i].num;
                activeDiscountCode = discountPairs[i].code;
              } else {
                break;
              }
            }

            if (activeDiscount !== null) {
              pricedisc = price * (1 - activeDiscountNum / 100);
              checkouturl = "/checkout"; // IA 2026-10-01: Bundle savings is automatic, no code
            } else {
              displayprice = 'style="display:none"';
              checkouturl = "/checkout";
            }
          }

          function priceupdateTotalItem(value) {
            pricecheckDiscounts();
          }

          priceupdateTotalItem(discount1item);
          priceupdateTotalItem(discount2item);
          priceupdateTotalItem(discount3item);
          priceupdateTotalItem(discount4item);
          priceupdateTotalItem(discount5item);
          if (window.IA_BUNDLE_SHOW_DISCOUNT === false) { pricedisc = price; displayprice = 'style="display:none"'; }

          // const cartAlertEl = document.querySelector('.cart-count-data');

          // if (cartAlertEl) {
          //   // Clear and re-add text to trigger announcement
          //   cartAlertEl.style.display = 'block'; // in case it was hidden via CSS
          //   cartAlertEl.setAttribute("aria-hidden", "false");
          //   cartAlertEl.setAttribute("aria-expanded", "true");

          //   // Clear content first
          //   cartAlertEl.textContent = '';
            
          //   setTimeout(() => {
          //     cartAlertEl.textContent = 'Your Product Successfully Added To Cart';
          //   }, 100);

          //   // Optionally hide it again after 3 seconds
          //   setTimeout(() => {
          //     cartAlertEl.setAttribute("aria-hidden", "true");
          //     cartAlertEl.setAttribute("aria-expanded", "false");
          //     cartAlertEl.style.display = 'none';
          //   }, 3000);
          // }


          $(".selected-product-div").prepend(`
            <div class="discount-active-product custom-added-product-info inner-discount-box" data-pid="${$(
              this
            ).find(".item-count")
              .data("varid")}">
            <div class="discount-product-content-info">
            <div class="custom-added-product-media">
              <img src="${$(this).find(".item-count").data("pimage")}"/>
            </div>
            <div class="custom-added-product-content">
              <div class="custom-added-product-title">${$(this)
                .find(".item-count")
                .data("ptitle")}</div>
              <div class="custom-added-product-price">
              <del ${displayprice}>${Shopify.formatMoney(price, symbol + "{{amount}}")}</del>
              <span>${Shopify.formatMoney(
                pricedisc,
                symbol + "{{amount}}"
              )}</span>
              </div>
              <div class="custom-added-product-edit" role="Button" aria-label="product remove">
               Remove
              </div>
            </div>
            </div>
            <div class="discount-quantity">
              <button class="quantity-button qty-minus" role="product quantity decrease" aria-label="product quantity decrease">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" class="minus-accordion">
                  <path d="M22.1667 15.1644H5.83334L5.83334 12.8311H22.1667V15.1644Z" fill="black"/>
                </svg>
              </button>
              <input type="number" role="product quantity value" aria-label="product quantity value" value="${$(this)
                .find(".item-count")
                .val()}" id="">
              <button class="quantity-button qty-plus" role="product quantity increase" aria-label="product quantity increase">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" class="plus-accordion">
                  <path d="M22.1667 15.1644H15.1667V22.1644H12.8333V15.1644H5.83334V12.8311H12.8333V5.83105H15.1667V12.8311H22.1667V15.1644Z" fill="black"/>
                </svg>
              </button>
            </div>
          </div>`);
        });

        $(".discount-active-product .qty-plus").click(function () {
          var elem = $(
            ".product-list-wrapper-main[data-varid='" +
              $(this).parents(".discount-active-product").data("pid") +
              "']"
          );
          elem.addClass("active");
          var qty = Number(elem.find(".item-count").val()) + 1;
          elem.find(".item-count").val(qty);
          elem.find(".totaladdedproduct").html("(" + qty + ")");
          setSelectedView();
        });

        $(".discount-active-product .qty-minus").click(function () {
          var elem = $(
            ".product-list-wrapper-main[data-varid='" +
              $(this).parents(".discount-active-product").data("pid") +
              "']"
          );
          elem.addClass("active");
          var qty = Number(elem.find(".item-count").val()) - 1;
          elem.find(".item-count").val(qty);
          elem.find(".totaladdedproduct").html("(" + qty + ")");

          if (qty == 0) {
            elem.removeClass("active");
            elem.find(".totaladdedproduct").html("");
            // cartAlertEl.textContent = 'Your Product Successfully Remove From Cart';
          }
          setSelectedView();
        });

        $(".discount-active-product .custom-added-product-edit").click(
          function () {
            var elem = $(
              ".product-list-wrapper-main[data-varid='" +
                $(this).parents(".discount-active-product").data("pid") +
                "']"
            );
            elem.removeClass("active");
            var qty = 0;
            elem.find(".item-count").val(qty);
            elem.find(".totaladdedproduct").html("(" + qty + ")");
            if (qty == 0) {
              elem.removeClass("active");
              elem.find(".totaladdedproduct").html("");
            }
            setSelectedView();

       

        
          }
        );

        function checkDiscounts() {
          activeDiscount = null;
          activeDiscountNum = null; 
          activeDiscountCode = null;

          for (let i = 0; i < discountPairs.length; i++) {
            if (totalitem >= discountPairs[i].value) {
              activeDiscount = discountPairs[i].value;
              activeDiscountNum = discountPairs[i].num;
              activeDiscountCode = discountPairs[i].code;
            } else {
              break;
            }
          }

          if (activeDiscount !== null) {
            $(".discount-product").each(function () {
              const stepValue = parseInt(
                $(this).data("step").replace("step-", ""),
                10
              );
              if (stepValue <= totalitem) {
                $(this).hide();
              } else {
                $(this).show();
              }
            });


            // Clear previous active
            $('.discount-items').removeClass('active');

            // Compute savings (optional display)
            const totalsaving = totalprice * (activeDiscountNum / 100);
           
            // Pick the active item once
            const $activeItem = $(`.discount-items[data-step="step-${activeDiscount}"]`);
            $('.discount-items').attr('aria-label','');
            // Activate + set accessible label
            $activeItem
              .addClass('active')
              .attr('aria-label', `You got ${activeDiscountNum}% discount for ${activeDiscount} items`);

            // Update UI pieces
            $('.saving-percentage').text(`${activeDiscountNum}%`);

            // If you show the absolute saving somewhere, uncomment the next line and ensure the element exists
            // $('.saving-amount').text(totalSaving.toFixed(2));


           

            $(".org-total-bundle-price").html(
              `${Shopify.formatMoney(totalprice, symbol + "{{amount}}")}`
            );

            $(".total-bundle-price").html(
              `${Shopify.formatMoney(
                window.IA_BUNDLE_SHOW_DISCOUNT === false ? totalprice : totalprice - totalsaving,
                symbol + "{{amount}}"
              )}`
            );

            $(".saving-with-every-price").html(
              `${Shopify.formatMoney(totalsaving, symbol + "{{amount}}")}`
            );

            $(".product-list-wrapper-main").each(function () {
              var pprice = "";
              if (sval == "subscription") {
                pprice = Shopify.formatMoney(
                  Number($(this).find(".item-count").data("sellingprice")),
                  symbol + "{{amount}}"
                );
              } else {
                pprice = Shopify.formatMoney(
                  Number($(this).find(".item-count").data("pprice")),
                  symbol + "{{amount}}"
                );
              }

              var discprice = "";
              if (sval == "subscription") {
                discprice =
                  Number($(this).find(".item-count").data("sellingprice")) *
                  (1 - activeDiscountNum / 100);
              } else {
                discprice =
                  Number($(this).find(".item-count").data("pprice")) *
                  (1 - activeDiscountNum / 100);
              }

              var pricenow = Shopify.formatMoney(
                discprice,
                symbol + "{{amount}}"
              );
              var pricehtml = window.IA_BUNDLE_SHOW_DISCOUNT === false ? `${pprice}` : `${pricenow} <del>${pprice}</del>`;
              $(this).find(".custom_p_price").html(pricehtml);
            });

            checkouturl = "/checkout"; // IA 2026-10-01: Bundle savings is automatic, no code
          } else {
            console.log("totalitem==" + totalitem);
            if (totalitem > 0) {
              $(".discount-product").show();
              $('.discount-product[data-step="step-0"]').hide();  
            } else {
              $(".discount-product").show();
            }

            $(".discount-items").removeClass("active");
            $(".saving-percentage").text("0%");
            var totalsaving = 0;
            $(".saving-with-every-price").html(
              `${Shopify.formatMoney(totalsaving, symbol + "{{amount}}")}`
            );

            $(".org-total-bundle-price").html(
              `${Shopify.formatMoney(totalprice, symbol + "{{amount}}")}`
            );

            $(".total-bundle-price").html(
              `${Shopify.formatMoney(totalprice, symbol + "{{amount}}")}`
            );

            $(".product-list-wrapper-main").each(function () {
              var pprice = "";
              if (sval == "subscription") {
                pprice = Shopify.formatMoney(
                  Number($(this).find(".item-count").data("sellingprice")),
                  symbol + "{{amount}}"
                );
              } else {
                pprice = Shopify.formatMoney(
                  Number($(this).find(".item-count").data("pprice")),
                  symbol + "{{amount}}"
                );
              }
              var pricehtml = `${pprice}`;
              $(this).find(".custom_p_price").html(pricehtml);
            });

            checkouturl = "/checkout";
          }
        }

        function updateTotalItem(value) {
          checkDiscounts();
        }

        updateTotalItem(discount1item);
        updateTotalItem(discount2item);
        updateTotalItem(discount3item);
        updateTotalItem(discount4item);
        updateTotalItem(discount5item);

        if (totalitem > 0) {
          var role = 'button'
          $(".custom-product-checkout-main").removeClass("disabled");
          $(".custom-product-checkout-main").attr("role",role);
        } else {
          var role = 'Disabled button'
          $(".custom-product-checkout-main").addClass("disabled");
          $(".custom-product-checkout-main").attr("role",role);
          
        }
      }

      $(".custom-product-checkout-main")
        .unbind()
        .click(function () {
          sval = iaSubMode();
          const url = new URL(window.location.href);
          url.searchParams.set("bundle", "true");
          window.history.replaceState(null, null, url);
          $(".error-msg").remove();
          var totalitem = 0;
          var totalprice = 0;
          $(".product-list-wrapper-main.active").each(function () {
            totalitem = totalitem + Number($(this).find(".item-count").val());

            var price = "";
            if (sval == "subscription") {
              price =
                Number($(this).find(".item-count").data("sellingprice")) *
                Number($(this).find(".item-count").val());
            } else {
              price =
                Number($(this).find(".item-count").data("pprice")) *
                Number($(this).find(".item-count").val());
            }

            totalprice = totalprice + price;
          });

          var pricedisc = totalprice;
          var displayprice = "";

          function totalheckDiscounts() {
            activeDiscount = null;
            activeDiscountNum = null;
            activeDiscountCode = null;

            for (let i = 0; i < discountPairs.length; i++) {
              if (totalitem >= discountPairs[i].value) {
                activeDiscount = discountPairs[i].value;
                activeDiscountNum = discountPairs[i].num;
                activeDiscountCode = discountPairs[i].code;
              } else {
                break;
              }
            }

            if (activeDiscount !== null) {
              pricedisc = totalprice * (activeDiscount / 100);
              checkouturl = "/checkout"; // IA 2026-10-01: Bundle savings is automatic, no code
              console.log("checkouturl===" + checkouturl);
            } else {
              checkouturl = "/checkout";
            }
          }

          function totalupdateTotalItem(value) {
            totalheckDiscounts();
          }

          totalupdateTotalItem(discount1item);
          totalupdateTotalItem(discount2item);
          totalupdateTotalItem(discount3item);
          totalupdateTotalItem(discount4item);
          totalupdateTotalItem(discount5item);

          $(this).find(".loading__spinner").removeClass("hidden");
          $(this).find(".atc-text").css("opacity", "0");
          var this2 = this;
          var bundleadded = false;
          var updates = {};
          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (cartdata) {
              for (var i = 0; i < cartdata.items.length; i++) {
                var properties = cartdata.items[i].properties;
                if (properties["_BundleItem"]) {
                  bundleadded = true;
                  updates[cartdata.items[i].key] = 0;
                }
                if (properties["_FreeGift"]) {
                  bundleadded = true;
                  updates[cartdata.items[i].key] = 0;
                }
              }
              if (bundleadded == true) {
                fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    updates: updates,
                  }),
                })
                  .then((response) => response.json())
                  .then((newCart) => {
                    addItems();
                  })
                  .catch(console.error);
              } else {
                addItems();
              }
            },
          });

          function addItems() {
            var iaMode = iaSubMode();
            var items = [];
            $(".product-list-wrapper-main.active").each(function () {
              var object = {};
              object["id"] = $(this).find(".item-count").data("varid");
              object["quantity"] = $(this).find(".item-count").val();
              var properties = { _BundleItem: true, _ia_bundle: "1" };
              object["properties"] = properties;
              // IA 2026-10-02: send a selling plan only when the toggle is on and the card has one.
              // IA 2026-10-03: plan = this card's own plan matching the CHECKED 30/60/90-day button (1/2/3 month, 15%).
              var iaFreq = $(".custom-subscription-container .button-container input[type='radio']:checked").val() || "1 month subscription with 15% discount";
              var iaOpt = $(this).find(".selling-plans").first().find("option").filter(function () {
                return $(this).attr("value") === iaFreq;
              }).first();
              var iaPlan = Number(iaOpt.attr("data-planid")) || Number($(this).find(".item-count").attr("data-sellingplan"));
              if (!iaOpt.length) console.warn("IA bundle: no plan '" + iaFreq + "' on variant " + object["id"]);
              if (iaMode === "subscription" && iaPlan > 0) {
                object["selling_plan"] = iaPlan;
              }
              items.push(object);
            });
            if (totalitem >= 3) {
              // var object = {};
              // object["id"] = $(".free-product-info").data("freepr");
              // object["quantity"] = 2;
              // var properties = { _FreeGift: true };
              // object["properties"] = properties;
              // items.push(object);
            }

            let formData = {
              items: items,
            };
            var iaBundleMsg = "We could not add your bundle, please try again.";
            var iaExpected = items.map(function (it) {
              return { id: Number(it.id), qty: Number(it.quantity) };
            });
            function iaBundleFail(msg) {
              $(this2).find(".loading__spinner").addClass("hidden");
              $(this2).find(".atc-text").css("opacity", "1");
              $(".error-msg").remove();
              var el = $('<div class="error-msg" role="alert" style="color:#b3261e;font-size:13px;margin-top:8px;text-align:center;"></div>');
              el.text(msg);
              $(this2).after(el);
            }
            if (!iaExpected.length) {
              iaBundleFail("Add at least one item to your bundle.");
              return;
            }
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              // IA 2026-10-01: check the add succeeded and every bundle line is in the cart before leaving the page.
              .then(function (response) {
                return response.json().then(
                  function (body) { return { ok: response.ok, body: body }; },
                  function () { return { ok: response.ok, body: null }; }
                );
              })
              .then(function (res) {
                if (!res.ok) {
                  iaBundleFail((res.body && (res.body.description || res.body.message)) || iaBundleMsg);
                  return;
                }
                return fetch(window.Shopify.routes.root + "cart.js", { headers: { Accept: "application/json" } })
                  .then(function (r) { return r.json(); })
                  .then(function (cart) {
                    var allIn = iaExpected.every(function (exp) {
                      var have = 0;
                      (cart.items || []).forEach(function (ci) {
                        if (Number(ci.variant_id) === exp.id && ci.properties && ci.properties._ia_bundle) have += Number(ci.quantity);
                      });
                      return have >= exp.qty;
                    });
                    if (!allIn) {
                      iaBundleFail(iaBundleMsg);
                      return;
                    }
                    window.location.href = checkouturl;
                  });
              })
              .catch(function (error) {
                console.error("Error:", error);
                iaBundleFail(iaBundleMsg);
              });
          }
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-bundle-builder", CustomBundleBuilder);

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem("cart", JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem("cart")) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) =>
      l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find(
        (i) => i.key == oi.key && i.quantity != oi.quantity
      );
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
          entry.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

const myCartWatcher = new CartWatcher();
myCartWatcher.init();
window.addEventListener("cart_changed", function () {
  checkcart();
});

function checkcart() {
  var freepr = Number($(".free-product-info").data("freepr"));
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cartdata) {
      var bundlepr = false;
      var bundleqty = 0;
      for (var i = 0; i < cartdata.items.length; i++) {
        if (cartdata.items[i].variant_id == freepr) {
          bundlepr = true;
        }
        $(".product-list-bundles").each(function () {
          if ($(this).data("varid") == cartdata.items[i].variant_id) {
            bundleqty = bundleqty + cartdata.items[i].quantity;
          }
        });
      }
      console.log(bundleqty + '  ' + bundlepr)
      var update = {};
      update[freepr] = 0;
      if (bundleqty < 3 && bundlepr == true) {
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: update,
          }),
        })
          .then((response) => response.json())
          .then((newCart) => {
            window.location.reload();
          })
          .catch(console.error);
      } else {
      }
       
    },
  });
}


class custommediagallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
      $(this).css({ opacity: 1, visibility: "visible" });

      var galleryThumbs = new Swiper(".mobile-thumnail-slider", {
        spaceBetween: 10,
        slidesPerView: 6,
        navigation: {
          nextEl: ".swiper-button-next-product-thumb",
          prevEl: ".swiper-button-prev-product-thumb",
        },
        breakpoints: {
          640: {
            slidesPerView: 7,
            spaceBetween: 14,
          },
          768: {
            slidesPerView: 8,
            spaceBetween: 14,
          },
          901: {
            slidesPerView: 6,
            spaceBetween: 14,
          },
        },
      });

      var galleryTop = new Swiper(".product-media-slider", {
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next-product",
          prevEl: ".swiper-button-prev-product",
        },
        thumbs: {
          swiper: galleryThumbs,
        },
        on: {
          slideChange: function () {
            setTimeout(() => {
              document
                .querySelectorAll(".product-media-slider .swiper-slide")
                .forEach((slide) => {
                  slide.setAttribute("aria-hidden", "true");
                });
              document
                .querySelectorAll(".product-media-slider .swiper-slide-active")
                .forEach((slide) => slide.removeAttribute("aria-hidden"));
            }, 50);
          },
        },
      });

      // window.addEventListener("changevariantmedia", function (e) {
      //   console.log(e.detail.mediaid);
      //   swipernew.slideTo(0);
      //   swiper2.slideTo(0);
      // });

      document.addEventListener("changevariantmedia", (e) => {
        var index = e.detail.index;
        galleryTop.slideTo(index);
        galleryThumbs.slideTo(index);
      });

      setTimeout(() => {
        document
          .querySelectorAll(".product-media-slider .swiper-slide")
          .forEach((slide) => {
            slide.setAttribute("aria-hidden", "true");
          });

        document
          .querySelectorAll(".product-media-slider .swiper-slide-active")
          .forEach((slide) => slide.removeAttribute("aria-hidden"));
      }, 50);
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}

customElements.define("custom-media-gallery", custommediagallery);





class CustomLogoGallery extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
      
          var directz = $(this).attr('direction');
          if(directz == 'true'){
             var SwiperTop = new Swiper('.custom-logo-carousel', {
            spaceBetween: 0,
            centeredSlides: true,
            speed: 4000,
            freeMode: true,
            autoplay: {
              delay: 0,
              reverseDirection:true
            },  
            loop: true,
            loopFillGroupWithBlank: true,
            slidesPerView:'auto',
            allowTouchMove: false,
            disableOnInteraction: true,
            navigation: {
              nextEl: ".logo-next",
              prevEl: ".logo-prev",
            },
          });
          }else{
             var SwiperTop = new Swiper('.custom-logo-carousel', {
            spaceBetween: 0,
            centeredSlides: true,
            speed: 4000,
            freeMode: true,
            autoplay: {
              delay: 0,
              reverseDirection:false
            },  
            loop: true,
            loopFillGroupWithBlank: true,
            slidesPerView:'auto',
            allowTouchMove: false,
            disableOnInteraction: true,
            navigation: {
              nextEl: ".logo-next",
              prevEl: ".logo-prev",
            },
          });
          }
          const playPauseBtn = document.getElementById("playPauseBtn");
          playPauseBtn.addEventListener("click", function () {
            if (SwiperTop.autoplay.running) {
              SwiperTop.autoplay.stop();
              playPauseBtn.classList.remove("paused");
              playPauseBtn.classList.add("running");
            } else {
              SwiperTop.autoplay.start();
              playPauseBtn.classList.remove("running");
              playPauseBtn.classList.add("paused");
            }
          });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}   
customElements.define("custom-logo-carousel", CustomLogoGallery);


